var closeIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewbox=\"0 0 40 40\">\n  <path stroke=\"#8091a4\" stroke-width=\"2.5\" d=\"M 10,10 L 30,30 M 30,10 L 10,30\" />\n</svg>";

export { closeIcon as default };
